// window.onscroll = function() {myFunction()}; 
// // if (window.matchMedia("(min-width:989px)").matches) {
// // }
//   var product_bar = document.querySelector(".section-header"); 
//   var sticky = product_bar.offsetTop+50;
//   function myFunction() {
//     if (window.pageYOffset > sticky) {
//       product_bar.classList.add("shopify-section-header-sticky")
//     } 
//     else {
//       product_bar.classList.remove("shopify-section-header-sticky");
//     }
//   }
 
$(document).ready(function(){
  $(".hasMegaMenuTitle--nav").hover(function(){ 
      var attr = $(this).attr('open');
    if (typeof attr !== 'undefined' && attr !== false) {
         $(this).removeAttr("open"); 
      } else {
    // $(this).attr('open');
     $(this).attr('open','open');
    }
});
$(".itg_blog_collection_slider").slick({
    dots: false,
    speed: 500,
    infinite: true,
    autoplay:true,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false
  });
  
 $('.itg_slider_for').slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  autoplay: true,
  arrows: false,
  speed:1500,
  fade: false,
  dots: true,
  asNavFor: '.itg_slider_nav'
});
$('.itg_slider_nav').slick({
  autoplay: true,
  speed: 1500,
  arrows: false,
  centerPadding:'400px',
  slidesToShow:1,
  slidesToScroll: 1,
  asNavFor: '.itg_slider_for',
  centerMode: true,
  focusOnSelect: true,
        responsive: [
              {
          breakpoint: 1140,
          settings: {
            slidesToShow: 1,
            centerPadding:'300px',
            slidesToScroll: 1
          }
        },
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 1,
            centerPadding:'200px',
            slidesToScroll: 1
          }
        },
        {
          breakpoint: 991,
          settings: {
            slidesToShow: 1,
            centerPadding:'200px',
            slidesToScroll: 1
          }
        },
         {
          breakpoint: 767,
          settings: {
            slidesToShow: 1,
            centerMode: false,
            slidesToScroll: 1
          }
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 1,
            centerMode: false,
            slidesToScroll: 1
          }
        }
      ]
});
$(".itg_blog_left .article-card-wrapper").slice(0, 6).show();

$("#loadMoreDesktop").on("click", function(e) {
        e.preventDefault(), $(".article-card-wrapper:hidden").slice(0, 4).slideDown(),
		$(".article-card-wrapper:hidden").length == 0 && $("#loadMoreDesktop").text("No Content").addClass("noContent")
    });

$("#loadMoreMobile").on("click", function(e) {
        e.preventDefault(), $(".article-card-wrapper:hidden").slice(0, 4).slideDown(),
		$(".article-card-wrapper:hidden").length == 0 && $("#loadMoreMobile").text("No Content").addClass("noContent")
    });  

  
  $(".testimonial-list").slick({
    dots: false,
    infinite: true,
    autoplay:true,
    pauseOnHover: false,
    pauseOnFocus: false,
    autoplaySpeed:5000,
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: true,
    prevArrow:'<button class="slick-prev slick-arrow" aria-label="Previous" type="button" style=""><svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="20" cy="20" r="20" fill="white"/><path d="M27 20H13" stroke="black" stroke-linecap="round" stroke-linejoin="round"/><path d="M20 27L13 20L20 13" stroke="black" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',
    nextArrow:'<button class="slick-next slick-arrow" aria-label="Next" type="button" style=""><svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="20" cy="20" r="19.5" fill="white" stroke="white"/><path d="M13 20H27" stroke="black" stroke-linecap="round" stroke-linejoin="round"/><path d="M20 13L27 20L20 27" stroke="black" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',
      responsive: [
        {
          breakpoint: 1023,
          settings: {
            slidesToShow: 2,
            centerMode: false,
            slidesToScroll: 1
          }
        },
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 2,
            centerMode: false,
            dots: true,
             arrows: false,
            slidesToScroll: 1
          }
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 1,
            centerMode: false,
            dots: true,
             arrows: false,
            slidesToScroll: 1
          }
        }
      ]
  });
 $(".home-press--list").slick({
    dots: false,
    infinite: true,
    autoplay:true,
    pauseOnHover: false,
    pauseOnFocus: false,
    autoplaySpeed:5000,
    slidesToShow: 4,
    slidesToScroll: 1,
    arrows: true,
    prevArrow:'<button class="slick-prev slick-arrow" aria-label="Previous" type="button" style=""><svg xmlns="http://www.w3.org/2000/svg" width="8" height="14" viewBox="0 0 8 14" fill="none"><path d="M7 13L1 7L7 1" stroke="black" stroke-width="0.83" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',
    nextArrow:'<button class="slick-next slick-arrow" aria-label="Next" type="button" style=""><svg xmlns="http://www.w3.org/2000/svg" width="8" height="14" viewBox="0 0 8 14" fill="none"><path d="M1 13L7 7L1 1" stroke="black" stroke-width="0.83" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',
    responsive: [
        {
          breakpoint: 1023,
          settings: {
            slidesToShow: 3,
            centerMode: false,
            slidesToScroll: 1
          }
        },
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 2,
            centerMode: false,
            dots: true,
            arrows: false,
            slidesToScroll: 1
          }
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 1,
            centerMode: false,
            dots: true,
             arrows: false,
            slidesToScroll: 1
          }
        }
      ]
  });
  var animation_elements = $.find('.ctt-add-animate');
  var web_window = $(window);
  function check_if_in_view() {
    var window_height = web_window.height();
    var window_top_position = web_window.scrollTop();
    var window_bottom_position = (window_top_position + window_height);
    $.each(animation_elements, function() {
      var element = $(this);
      var element_height = $(element).outerHeight();
      var element_top_position = $(element).offset().top;
      var element_bottom_position = (element_top_position + element_height);

      if ((element_bottom_position >= window_top_position) && (element_top_position <= window_bottom_position)) {
        element.addClass('slide-view');
      } else {
        element.removeClass('slide-view');
      }
    });

  }
  $(window).on('scroll resize', function() {
      check_if_in_view()
  });
  $(window).trigger('scroll');


});


$(document).ready(function(){
  $('.cstm_hover_btn .cstm_btn').hover(function(){
    var img_path = $(this).attr('image-path');
    
    $('.cstm_hover img').attr('src', img_path);
  });
  
  $('div#cstm--df4d0c88-35af-4c32-b112-a24609889cb7 .block_textconten.block_text').hover(function(){
    var img_path = $(this).attr('image-path');
    $(this).addClass('active-bg');
    $(this).siblings().removeClass('active-bg');
    $('div#cstm--df4d0c88-35af-4c32-b112-a24609889cb7 .about-us-img img').attr('src', img_path);
    
  });

$(".cdd-cstm-home-logo").slick({
    infinite: true,
    adaptiveHeight: true,
    slidesToShow: 6,
    slidesToScroll: 1,
    arrows: false,
    autoplay: true,
  	autoplaySpeed: 5000,
    dots: false,
     prevArrow:'<button class="slick-prev slick-arrow" aria-label="Previous" type="button" style=""><svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="20" cy="20" r="20" fill="white"/><path d="M27 20H13" stroke="black" stroke-linecap="round" stroke-linejoin="round"/><path d="M20 27L13 20L20 13" stroke="black" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',
    nextArrow:'<button class="slick-next slick-arrow" aria-label="Next" type="button" style=""><svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="20" cy="20" r="19.5" fill="white" stroke="white"/><path d="M13 20H27" stroke="black" stroke-linecap="round" stroke-linejoin="round"/><path d="M20 13L27 20L20 27" stroke="black" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',
    responsive: [ 
       {
        breakpoint: 1023,
        settings: {
          slidesToShow: 5
        }
      },
      {
        breakpoint: 749,
        settings: {
          slidesToShow: 3
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 2
        }
      }
    ]
  });
});

// $(document).ready(function(){
// //  $(".video-section__poster").click(function(){
// // //    alert('hi');
// //    $('.cdd-cstm-play-btn').trigger('click');
// //       $("iframe#ctt-video_url")[0].src += "?autoplay=1";
// //      });

// //  $(".video-section__poster").click(function(event){
// //     alert('hi');
// //     $(".ytp-large-play-button .ytp-button").trigger("click");
// //    $("iframe#ctt-video_url")[0].src += "?autoplay=1";
// // //     $('.ytp-large-play-button').trigger('pause');
    
// // });

//   });


//  product page 
$(document).ready(function(){
  $(".description-read-more").click(function() {
    $(".readmore").slideToggle("slow"); 
    if ($(this).text() == "Read More...") {
      $(this).text("Read Less");
      //     alert('less');
    } else if ($(this).text() == "Read Less") {
      $(this).text("Read More...");
      //     alert('less');
    }
  });
  
  $(".cstm_footer-heading").click(function() {
    var cstm_footer=$(this).data('id');
    $("#"+cstm_footer).slideToggle("slow");
  });
});


//  testimonial page 
// $(document).ready(function(){
//   $(".cdd-show-btn").click(function() {
//     $(".cdd-see-more").slideToggle("slow");
//   });
//   $(".cdd-show-btn-2").click(function() {
//     $(".cdd-see-more-2").slideToggle("slow");
//   });
// });

// $(document).ready(function() {
//   $(".cdd-show-btn").click(function() {
//     var wear = $(".cdd-show-btn").text();
//     if (wear == "Read More") {
      
//       $(".cdd-show-btn").text("Read Less");
//       $(".cdd-see-more").slideDown();
//     } else {
     
//       $(".cdd-show-btn").text("Read More");
//       $(".cdd-see-more").slideUp();
//     }
//   });
// });

$(document).ready(function(){
  $('.cdd-show-btn').click(function() {
    $('.cdd-see-more').slideToggle();
    if ($(this).text() == "Read More") {
      $(this).text("Read Less");
      //     alert('less');
    } else if ($(this).text() == "Read Less") {
      $(this).text("Read More");
      //     alert('less');
    }
  });

  $('.cdd-show-btn-2').click(function() {
    $('.cdd-see-more-2').slideToggle();
    if ($(this).text() == "Read More") {
      $(this).text("Read Less");
      //     alert('less');
    } else if ($(this).text() == "Read Less") {
      $(this).text("Read More");
      //     alert('less');
    } 
  });
  
// featured collection slider  
  $(".cstm-featured-collection").slick({
    infinite: true,
    adaptiveHeight: true,
    slidesToShow: 2,
    slidesToScroll: 1,
    arrows: true,
    autoplay: false,
  	autoplaySpeed: 5000,
    dots: false,
     prevArrow:'<button class="slick-prev slick-arrow" aria-label="Previous" type="button" style=""><svg xmlns="http://www.w3.org/2000/svg" width="8" height="14" viewBox="0 0 8 14" fill="none"><path d="M7 13L1 7L7 1" stroke="black" stroke-width="0.83" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',
    nextArrow:'<button class="slick-next slick-arrow" aria-label="Next" type="button" style=""><svg xmlns="http://www.w3.org/2000/svg" width="8" height="14" viewBox="0 0 8 14" fill="none"><path d="M1 13L7 7L1 1" stroke="black" stroke-width="0.83" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',
    responsive: [ 
       {
        breakpoint: 1023,
        settings: {
          slidesToShow: 1
        }
      },
      {
        breakpoint: 749,
        settings: {
          slidesToShow: 1
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1
        }
      }
    ]
  });
  

  

});

 $(document).ready(function(){
   if($(window).width() < 750){
// $(".cstm_feet-slider").slick({
//     infinite: true,
//     adaptiveHeight: true,
//     slidesToShow: 3,
//     slidesToScroll: 1,
//     arrows: true,
//     autoplay: false,
//   	autoplaySpeed: 5000,
//     dots: false,
//     prevArrow:'<button class="slick-prev slick-arrow" aria-label="Previous" type="button" style=""><svg xmlns="http://www.w3.org/2000/svg" width="8" height="14" viewBox="0 0 8 14" fill="none"><path d="M7 13L1 7L7 1" stroke="black" stroke-width="0.83" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',
//     nextArrow:'<button class="slick-next slick-arrow" aria-label="Next" type="button" style=""><svg xmlns="http://www.w3.org/2000/svg" width="8" height="14" viewBox="0 0 8 14" fill="none"><path d="M1 13L7 7L1 1" stroke="black" stroke-width="0.83" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',
//     responsive: [ 
//       {
//         breakpoint: 749,
//         settings: {
//           slidesToShow: 1
//         }
//       }
    
//     ]
//   });
   }
  }); 
   
 
   var myApp = new function () {
        this.printDiv = function () { 
//           var mywindow = window.open();
//           var content = document.getElementById('product__media_img').innerHTML;
//           mywindow.document.write(content);
//           mywindow.print();
          var mywindow = window.open();
          var content = document.getElementById('product__media_img').innerHTML;
          var realContent = document.body.innerHTML;
          mywindow.document.write(content);
          mywindow.document.close(); // necessary for IE >= 10
          mywindow.focus(); // necessary for IE >= 10*/
          mywindow.print();
          document.body.innerHTML = realContent;
          mywindow.close();
          return true;

        }
    }
   
   $(document).ready(function(){ 
     $(".product-form__input input[type=radio]+label").click(function() {
       var printtosize_text = $(this).text();
       var printtosize_text = printtosize_text.trim(); 
       $("#printtosize_tags").text(printtosize_text);
     });
     
     $('.application-video .video-section__poster').click(function(){ 
        var videoId = $(this).data('id');
//        alert(videoId);
//        $('.product-vedio-opup').hide();
       $('.youtube-iframe video').trigger('pause'); 
       $('.youtube-iframe').each(function(index) {
         $(this).attr('src', $(this).attr('src'));
         return false;
       }); 
  });
//         $('.youtube-iframe video').click(function(){ 
// //         var videoId = $(this).data('id');
// //        alert(videoId);
// //        $('.product-vedio-opup').hide();
//        $('.youtube-iframe video').trigger('pause'); 
//        $('.youtube-iframe').each(function(index) {
//          $(this).attr('src', $(this).attr('src'));
//          return false;
//        }); 
//   });

     // testimonial-video-slider

  $(".hj-testimonial-slider").slick({
    dots: false,
    infinite: true,
    autoplay:true,
    pauseOnHover: false,
    pauseOnFocus: false,
    autoplaySpeed:5000,
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: true,
    prevArrow:'<button class="slick-prev slick-arrow" aria-label="Previous" type="button" style=""><svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="20" cy="20" r="20" fill="white"/><path d="M27 20H13" stroke="black" stroke-linecap="round" stroke-linejoin="round"/><path d="M20 27L13 20L20 13" stroke="black" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',
    nextArrow:'<button class="slick-next slick-arrow" aria-label="Next" type="button" style=""><svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="20" cy="20" r="19.5" fill="white" stroke="white"/><path d="M13 20H27" stroke="black" stroke-linecap="round" stroke-linejoin="round"/><path d="M20 13L27 20L20 27" stroke="black" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',
      responsive: [
        {
          breakpoint: 1023,
          settings: {
            slidesToShow: 2,
            centerMode: false,
            slidesToScroll: 1,
            dots: false,
            arrows: true
          }
        },
        {
          breakpoint: 750,
          settings: {
            slidesToShow: 2,
            centerMode: false,
            dots: true,
            arrows: false,
            slidesToScroll: 1
          }
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 1,
            centerMode: false,
            dots: true,
            arrows: false,
            slidesToScroll: 1
          }
        }
      ]
 });
 
  $("buttons.vedio_puase_play_buttons").click(function() { 
       // var this_text_paly = $(this).find('span.ttext-play');
       // var this_text_pause = $(this).find('span.ttext-pause');
       var this_text_paly = $(this).find('svg.vedio_puase_play_icons');
       var this_text_pause = $(this).find('span.vedio_puase_pause_icons');
        var video_id = $(this).data('id'); 
       if ($("#"+video_id).get(0).paused) {
        $('svg.vedio_puase_play_icons').show();
        $('.vedio_puase_pause_icons').hide();
        $("video").trigger('pause');
        $("#"+video_id).trigger('play');
          this_text_paly.hide();
          this_text_pause.show(); 
          $("#"+video_id).prop('muted', false);
         $('.hj-testimonial-slider').slick('slickPause'); 
         } else {
          $("#"+video_id).trigger('pause');
            this_text_paly.show();
           this_text_pause.hide();
          $("#"+video_id).prop('muted', true);
          $('.hj-testimonial-slider').slick('slickPlay'); 
       }
  });
});

 // $(document).ready(function(){ 
 // $('.swatches-name').on( "click", function() { 
 //   var get = $(this).attr('data-attr');
 //   //alert(get);
 //   $('.itg_print a').attr('href', get);
 // });
 // });

 // $(document).ready(function(){ 
 // $('#ProductInfo-quickadd-template--15995431321827__main .swatches-name').on( "click", function() { 
 //   var get = $(this).attr('data-attr');
 //   //alert(get);
 //   $('#ProductInfo-quickadd-template--15995431321827__main .itg_print a').attr('href', get);
 // });
 // });



 // $(document).ready(function(){ 
 // $('.product-form__input input[type=radio]:checked+label.swatches-name').on( "click", function() { 
 //   var get = $(this).attr('data-attr');
 //   alert(get);
 //   $('.quick-add-modal__content .itg_print a').attr('href', get);
 // });
 // });
 